import React__default from 'react';

const MobileTableCell = ({ primary, secondary, date, actions, before, children }) => {
    return (React__default.createElement("td", { className: "MobileTableCell" },
        React__default.createElement("div", { className: "MobileTableCell-container" },
            before && (React__default.createElement("div", { className: "MobileTableCell-before" }, before)),
            React__default.createElement("div", { className: "MobileTableCell-content" },
                date && React__default.createElement("div", { className: "MobileTableCell-date" }, date),
                primary && React__default.createElement("div", { className: "MobileTableCell-primary" }, primary),
                secondary && React__default.createElement("div", { className: "MobileTableCell-secondary" }, secondary),
                children),
            actions && React__default.createElement("div", { className: "MobileTableCell-actions" }, actions))));
};

export { MobileTableCell as M };
